import { Button } from 'app/components/ui/button'
import { type LinkProblem, linkProblemScreen, type Practice } from 'app/lib/forms/paperworkLink'

type Props = { problem: LinkProblem; practice?: Practice; onRetry?: () => void }

export function LinkProblemScreen({ problem, practice, onRetry }: Props) {
  const { title, body } = linkProblemScreen(problem, practice)
  const showCall = practice?.phone && problem !== `invalid` && problem !== `unreachable`
  return (
    <div className="theme-light min-h-screen bg-surface text-strong">
      <main className="mx-auto flex w-full max-w-md flex-col gap-4 px-4 py-16">
        {practice && <span className="text-lg font-semibold text-strong">{practice.displayName}</span>}
        <h1 className="text-2xl font-semibold text-strong">{title}</h1>
        <p className="text-base leading-relaxed text-default">{body}</p>
        {showCall && (
          <Button asChild variant="primary" size="xl" className="w-full">
            <a href={`tel:${practice.phone}`}>{`Call ${practice.phone}`}</a>
          </Button>
        )}
        {problem === `unreachable` && onRetry && (
          <Button variant="primary" size="xl" className="w-full" onClick={onRetry}>
            Try again
          </Button>
        )}
      </main>
    </div>
  )
}
